var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabsIsShown),expression:"tabsIsShown"}],class:_vm.$style.group,attrs:{"role":"tablist"}},[_vm._t("tabs",null,{"tabs":_vm.tabs,"tab":_vm.tab})],2),_vm._v(" "),_vm._t("content",null,{"tabs":_vm.tabs,"tab":_vm.tab})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }